module.exports = __webpack_public_path__ + "img/list1.87a67f60.jpg";